module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/passthrough.js
// module id = 1244
// module chunks = 0